import React, { type ReactNode } from 'react';
import { JSErrorPageAsync } from '@jira/platform__js-error-page/src/JSErrorPageAsync.tsx';
import { MaintenanceModePage } from '@jira/servicedesk__cmdb-maintenance-page/src/MaintenanceModePage.tsx';
import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import type { ContainerProps } from './ContainerProps.types.tsx';
import {
	CmdbArchitectureStoreContainer,
	useCmdbArchitectureStore,
} from './useIsNewCmdbArchitecture.tsx';

type CmdbArchitectureContainer = Pick<ContainerProps, 'workspaceId'> & { children?: ReactNode };

export const CmdbArchitectureContainer = ({
	workspaceId,
	children,
}: CmdbArchitectureContainer): React.JSX.Element => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return (
		<CmdbArchitectureStoreContainer
			isGlobal
			workspaceId={workspaceId}
			createAnalyticsEvent={createAnalyticsEvent}
		>
			<MigrationHandler>{children}</MigrationHandler>
		</CmdbArchitectureStoreContainer>
	);
};

// Only exported for testing purposes
export const MigrationHandler = ({
	children,
}: {
	children?: ReactNode;
}):
	| string
	| number
	| boolean
	| Iterable<React.ReactNode>
	| React.JSX.Element
	| null
	| undefined => {
	const { loading, error, migrationStatus } = useCmdbArchitectureStore();

	if (error) {
		return <JSErrorPageAsync />;
	}

	if (loading || !migrationStatus) {
		return <UFOLoadHold name="migration-status" />;
	}

	if (migrationStatus.blockWriteTraffic) {
		return <MaintenanceModePage />;
	}

	return children;
};
